import ArbitratorCommonContent from "./ArbitratorCommonContent";

export default ArbitratorCommonContent;
